export const trendClass = (trend) => {
  if (trend === "increased") return "du-odds-value--up";
  if (trend === "decreased") return "du-odds-value--down";
  return "";
};

export const hasTrend = (trend) =>
  trend === "increased" || trend === "decreased";

